<template>
    <body>
    <div class="flex-center position-ref full-height">
        <div class="code">
            {{ code }}
        </div>

        <div class="message" style="padding: 10px;">
            {{ message }}
        </div>
    </div>
    </body>
</template>

<script>
  export default {
    props: {
      code: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>
    html, body {
        background-color: #fff;
        color: #636b6f;
        font-weight: 100;
        height: 100%;
        margin: 0;
    }

    .full-height {
        height: 100%;
    }

    .flex-center {
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .position-ref {
        position: relative;
    }

    .code {
        border-right: 2px solid;
        font-size: 26px;
        padding: 0 15px 0 15px;
        text-align: center;
    }

    .message {
        font-size: 18px;
        text-align: center;
    }
</style>
